<div class="wrapper mat-elevation-z8">
    <div class="available-types mat-elevation-z4">
        <mat-chip-list>
            <mat-chip *ngFor="let type of AvailableTypes$ | async" [selected]="type.selected" (click)="ToggleResultType($event, type.type)">
                <fa-icon [icon]="type.icon"></fa-icon>
                {{ type.name }}
            </mat-chip>
        </mat-chip-list>
    </div>
    <div class="results" *ngIf="(displayResultsFiltered$ | async).length != 0">
        <ng-container *ngFor="let ret of displayResultsFiltered$ | async">
            <a *ngIf="ret.data.route" class="data {{ ret.data.theme }} theme-override" role="button" [routerLink]="ret.data.route" [queryParams]="ret.data.queryParams">
                <ng-container [ngTemplateOutlet]="content"></ng-container>
            </a>
            <div *ngIf="!ret.data.route && ret.data.onClick" (click)="ret.data.onClick()" class="data {{ ret.data.theme }} theme-override">
                <ng-container [ngTemplateOutlet]="content"></ng-container>
            </div>
            <ng-template #content>
                <div class="icon-wrapper app-background-primary">
                    <fa-icon [icon]="ret.data.icon"></fa-icon>
                </div>
                <span class="result-text">
                    <ng-container *ngFor="let p of ret.data.text">
                        <span [innerHTML]="p"></span>
                    </ng-container>
                </span>
            </ng-template>
        </ng-container>
    </div>

    <ng-container *ngIf="Returns.TotalResults === 0">
        <div class="data">
            <fa-icon icon="search"></fa-icon>
            <a>Keine Daten gefunden...</a>
        </div>
    </ng-container>
<!--    <ng-container *ngIf="Returns.contracts">-->
<!--        <div class="data" *ngFor="let ret of Returns.contracts.data?.return">-->
<!--            <span class="icon">-->
<!--                <fa-icon icon="file-signature"></fa-icon>-->
<!--            </span>-->
<!--            <a [routerLink]="['/vertraege', ret.entity.id]">-->
<!--                {{FormatData(Returns.contracts.event, ret)}}-->
<!--            </a>-->
<!--        </div>-->
<!--    </ng-container>-->
<!--    <ng-container *ngIf="Returns.doctors">-->
<!--        <div class="data" *ngFor="let ret of Returns.doctors.data?.return">-->
<!--            <span class="icon">-->
<!--                <fa-icon icon="user-md"></fa-icon>-->
<!--            </span>-->
<!--            <a [routerLink]="['/kundenverwaltung', ret.entity.customerId, 'behandler', ret.entity.id]">-->
<!--                {{FormatData(Returns.doctors.event, ret)}}-->
<!--            </a>-->
<!--        </div>-->
<!--    </ng-container>-->
</div>
